// Explicit section hierarchy for documents and collections.
import { richText } from './richText';
export const section = ({ id, title, description, collapsible, blocks, widgets, sections, }) => ({
    id,
    title: title ? richText(title) : undefined,
    description: description ? richText(description) : undefined,
    collapsible,
    blocks,
    widgets,
    sections,
});
export const collectionSection = ({ id, title, description, blocks, widgets, }) => ({
    id,
    title: title ? richText(title) : undefined,
    description: description ? richText(description) : undefined,
    blocks,
    widgets,
});
//# sourceMappingURL=section.js.map